<template>
    <div class="header-search sm:!w-64 md:!w-96" ref="header">
            <GlobalSearch class="header-search__top !mb-0" />
        </div>
</template>

<script>
import GlobalSearch from '@/components/UI/globalSearch/index.vue'
import {mapActions} from 'vuex'
import {mapGetters} from 'vuex'
import FileList from "@/views/search/components/FileList.vue";

export default {
    name: 'HeaderSearch',

    data: () => ({
        isActiveContent: false,
    }),

    components: {
        FileList,
        GlobalSearch
    },

    computed: {
        ...mapGetters(['user', 'findedUsers', 'findedCourses', 'findedFiles', 'searchState']),
        results() {
            return {
                courses: this.findedCourses?.courses?.slice(0, 3) || [],
                users: this?.findedUsers?.slice(0, 3) || [],
                files: this?.findedFiles?.slice(0, 3) || []
            }
        },
        isNotFound() {
            if (!this.searchState) {
                return false;
            }
            return !this.results.courses.length && !this.results.files.length && !this.results.users.length
        }
    },

    methods: {
        ...mapActions(['setSearchHiddenOverflow']),
        activeSearch(boolean) {
            this.setSearchHiddenOverflow(boolean)
            return this.isActiveContent = boolean
        },
        routeToUser(item) {
            this.$router.push(`/profile/${item.id}`)
        },
        onClickOutside(e) {
            if (!this.$refs.header.contains(e.target)) {
                this.isActiveContent = false
                this.setSearchHiddenOverflow(false)
            }
        },
        goToSearch() {
            //eslint-disable-next-line
            if (!!this.user) {
                this.$router.push({name: 'Search'})
            } else this.$router.push({name: 'Auth'})
        },
        routeToCourse(item) {
            this.$router.push(`/course/${item.id}`)
            this.isActiveContent = false
        }
    },

    unmounted() {
        document.removeEventListener('click', this.onClickOutside)
    },

    mounted() {
        document.addEventListener('click', this.onClickOutside);
    },
}
</script>

<style lang="scss" scoped>
@import '../scss/header-search.scss';
</style>

